import { ApiError } from '@/api/client';

export function projectErrorMessage(err: unknown): string {
  if (err instanceof ApiError) {
    if (err.code === 'DUPLICATE_SLUG') return 'Deze slug bestaat al. Kies een andere.';
    if (err.code === 'CONFIRM_SLUG_MISMATCH')
      return 'Slug komt niet overeen. Typ exact de project-slug.';
    if (err.code === 'CAMPAIGN_RUNNING') return err.message;
    return err.message;
  }
  if (err instanceof Error) return err.message;
  return 'Er ging iets mis.';
}
